<template>
  <div class="text-center" />
</template>

<script>
export default {
  name: 'Footer',
};
</script>
